<template>
  <div id="app" :class="GameList && GameList.length > 0 ? 'bgname' : ''">
    <!-- 判断是否断网了 -->
    <div class="box">
      <keep-alive>
        <!--使用keep-alive会将页面缓存-->
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <!-- 敬请期待  coming soon-->
    <div v-show="tipMsg.show" class="coming_soon">
      <div class="coming_soon_bg"></div>
      <div class="coming_soon_text">{{ tipMsg.msg }}</div>
    </div>
    <!--  @setEstimateModel="getEstimateModel" -->
    <!-- 评价弹出框 -->
    <!-- <estimate :estimateModel="evaluationState.popup"></estimate> -->
    <appLogin></appLogin>
    <!-- 提醒弹框 -->
    <!-- <appTip v-if="appTipVisible"></appTip> -->

    <!-- <div class="btnaa" @click="postjson">1233</div> -->
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
import estimate from "@/components/model/estimate";

import appLogin from "@/components/model/login";
import appTip from "@/components/model/tip";

// import { log } from "util";
export default {
  components: {
    estimate,
    appLogin,
    appTip
  },
  name: "App",
  data() {
    return {
      isIPad: false,
      appTipVisible: false
    };
  },
  computed: {
    ...mapState("user", ["lang", "tipMsg"]),
    ...mapState("game", ["GameList", "evaluationState"])
  },
  created() {
    // 测试直接唤起tga app
    // location.href = 'tga://host:8080/gamedetail?gameId=78'
    // if (!localStorage.getItem("appId")) {
    //   // localStorage.setItem("appId", "124cad5d6fe64b55862adbbffbd9e1af");
    //   localStorage.setItem("appId", "323dd24524b846e0bb26ef8911a28a20");
    // }
    this.getinfo();

    if (localStorage.getItem("lang")) {
      if (localStorage.getItem("lang") == "tr") {
        this.$i18n.locale = "tr";
      } else if (localStorage.getItem("lang") == "ja") {
        this.$i18n.locale = "ja";
      } else {
        this.$i18n.locale = "en";
      }
    } else {
      this.$i18n.locale = "en";
    }

    // this.$i18n.locale = this.lang
    document.title = this.$t("index.nav");

    let ua = navigator.userAgent;
    let isios = ua.indexOf("Mac OS") >= 0;
    let isIphone = ua.indexOf("iPhone OS") >= 0;
    if (isios && !isIphone) {
      this.isIPad = true;
    } else {
      this.isIPad = false;
    }
  },
  mounted() {},
  watch: {
    lang(curVal, oldVal) {
      this.$i18n.locale = this.lang;
      document.title = this.$t("index.nav");
    }
  },
  methods: {
    ...mapActions("user", ["BipLogin", "userInfo"]),
    ...mapActions("game", ["checkUserGameEvaluationState", "userActiveReport"]),
    // jsonPost
    // async postjson() {
    //   const res = await this.jsonPost({
    //     $axios: this.$axios
    //   });
    // },

    // 查询评分系统
    async getCheckUserGameEvaluationState() {
      // const res = await this.checkUserGameEvaluationState({
      //   $axios: this.$axios,
      //   type: 1,
      // });
    },

    // 获取评价传上来的数据
    // getEstimateModel(data) {
    // this.estimateModel = data;
    // },

    //获取用户信息
    async getUserInfo() {
      const res = await this.userInfo({
        $axios: this.$axios,
        lang: localStorage.getItem("lang"),
        appId: configs.bipAppId(),
        token: localStorage.getItem("Bearer")
      });
      return;
    },

    async login() {
      try {
        const res = await tgaPlatformSDK.uc.login({
          fpId: localStorage.getItem("msisdn")
            ? localStorage.getItem("msisdn") + ""
            : "",
          appId: configs.bipAppId()
        });
        console.log("res", res);
        localStorage.setItem("Bearer", res.accessToken);
        localStorage.setItem("refreshToken", res.refreshToken);
        this.BipLogin({
          $axios: this.$axios,
          ...res.user
        });
      } catch (error) {
        console.log("tploginerror", error);
      }


      return;
    },

    async getinfo() {
      console.log("获取信息");
      let txn_id,
        msisdn,
        nickname,
        avatar,
        appId,
        lang,
        token,
        refreshToken,
        appversion,
        theme,
        navigationbar;

      // 判断token和refreshToken是否相同 相同清空
      if (
        localStorage.getItem("Bearer") == localStorage.getItem("refreshToken")
      ) {
        localStorage.removeItem("Bearer");
        localStorage.removeItem("refreshToken");
      }

      if (configs.GetQueryString("appId") || this.$route.query.appId) {
        // 判断是否是可以自动登录
        txn_id =
          configs.GetQueryString("txnId") ||
          this.$route.query.txnId ||
          configs.GetQueryString("txn_id") ||
          this.$route.query.txn_id;
        msisdn = configs.GetQueryString("msisdn") || this.$route.query.msisdn;
        nickname =
          configs.GetQueryString("nickname") || this.$route.query.nickname;
        appId = configs.GetQueryString("appId") || this.$route.query.appId;
        lang = configs.GetQueryString("lang") || this.$route.query.lang;
        token = configs.GetQueryString("token") || this.$route.query.token;
        refreshToken =
          configs.GetQueryString("refresh-token") ||
          this.$route.query["refresh-token"];
        // 拿到传过来的版本号
        appversion = configs.GetQueryString("appversion");
        localStorage.setItem("theme", theme);
      } else {
        if (window.TgaBridge) {
          // 判断是否含有appId参数 有则是从原生端跳转过来的
          // const userInfo = await TgaBridge.getUserParam();
          // const appInfo = await TgaBridge.getAppParam();
          // if (userInfo) {
          //   txn_id = userInfo.txnId;
          //   msisdn = userInfo.msisdn;
          //   nickname = userInfo.nickname;
          //   token = userInfo.token;
          //   refreshToken = userInfo["refresh-token"];
          //   avatar = userInfo.avatar;
          // }
          // if (appInfo) {
          //   appId = appInfo.appId;
          //   lang = appInfo.lang;
          //   appversion = appInfo.appversion;
          //   theme = appInfo.theme;
          //   navigationbar = appInfo.navigationbar;
          // }
        } else if (window.Bridge) {
          const userInfo = await window.Bridge.system.gameCenterUserParam();
          const appInfo = await window.Bridge.system.gameCenterAppParam();
          if (userInfo) {
            txn_id = userInfo.txnId;
            msisdn = userInfo.msisdn;
            nickname = userInfo.nickName;
            token = userInfo.token;
            refreshToken = userInfo.refreshToken;
            avatar = userInfo.avatar;
          }
          if (appInfo) {
            appId = appInfo.appId;
            // lang = appInfo.lang;
            lang = appInfo.lang.split("-")[0];
            appversion = appInfo.appVersion;
            theme = appInfo.theme;
            navigationbar = appInfo.navigationBar;
          }
        }
        localStorage.setItem("theme", theme);
        // 设置
        switch (localStorage.getItem("theme")) {
          case "dark-blue":
            import("@/css/customized/khalasPay.css");
            break;
          case "dark":
            import("@/css/customized/dark.css");
            break;
          case "candlelight":
            import("@/css/customized/candlelight.css");
            break;
          case "lavender":
            import("@/css/customized/lavender.css");
            break;
          case "orange":
            import("@/css/customized/orange.css");
            break;
          case "night-blue":
            import("@/css/customized/night-blue.css");
            break;
          default:
            import("@/css/customized/default.css");
            break;
        }
      }

      if (!avatar) {
        avatar = "https://cdn.just4fun.sg/resource/avatars/default.png";
      }
      localStorage.setItem("avatar", avatar);

      if (appversion) {
        localStorage.setItem("appversion", appversion);
      }
      if (!msisdn) {
        msisdn && localStorage.setItem("msisdn", msisdn);
      }

      localStorage.setItem("BIPVersion", "22");
      if (!appId) {
        this.$root.adOff = true;
        // appId = "323dd24524b846e0bb26ef8911a28a20";
        appId = tgaPlatformSDK.util.url.getDefaultAppId();
      }
      if (!txn_id) {
        txn_id = "156000000016";
      }
      if (!msisdn) {
        msisdn = "156000000016";
      }
      if (!lang) {
        lang = window.navigator.language.substring(0, 2);
      }
      console.log("lang", lang);
      this.$i18n.locale = lang;

      txn_id && localStorage.setItem("txn_id", txn_id);
      msisdn && localStorage.setItem("msisdn", msisdn);
      nickname && localStorage.setItem("nickname", decodeURI(nickname));
      lang && localStorage.setItem("lang", lang);
      localStorage.setItem("tacitlyLang", "en");
      appId && localStorage.setItem("appId", appId);
      token && localStorage.setItem("Bearer", token);
      refreshToken && localStorage.setItem("refreshToken", refreshToken);
      this.$root.loading = true;

      // if (!localStorage.getItem("refreshToken")) {
      //   await this.login();
      // } else {
      //   await this.getUserInfo();
      // }
      this.appTipVisible = true;
      this.getCheckUserGameEvaluationState();
    }
  }
};
</script>
<style>
/* .btnaa {
  font-size: 0.4rem;
  width: 100%;
  height: 2rem;
  background-color: red;
  position: fixed;
  top: 3rem;
  left: 0;
  z-index: 1000;
} */
@media screen and (min-width: 1000px) {
  .box {
    max-width: 800px !important;
    margin: 0 auto !important;
  }
}

.box {
  width: 100%;
  height: 100%;
}

body,
html {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

.no_ipad {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: var(--bg);
  z-index: 1000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 2rem;
}

.no_ipad_text {
  font-size: 0.42rem;
  color: #303d46;
  margin-top: 0.8rem;
  line-height: 0.6rem;
  text-align: center;
}

* {
  -webkit-touch-callout: none;
  /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -khtml-user-select: none;
  /*早期浏览器*/
  -moz-user-select: none;
  /*火狐*/
  -ms-user-select: none;
  /*IE10*/
  user-select: none;
}

div {
  -webkit-touch-callout: none;
  /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -khtml-user-select: none;
  /*早期浏览器*/
  -moz-user-select: none;
  /*火狐*/
  -ms-user-select: none;
  /*IE10*/
  user-select: none;
}

input {
  background: none;
  outline: none;
  border: none;
  -webkit-user-select: auto;
  /*webkit浏览器*/
  /* border:1px solid #ccc; */
}

input:focus {
  border: none;
}

#app {
  width: 100%;
  height: 100%;
}

.bgname {
  /* background-color: #ffffff; */
  background-color: var(--bg);
}

a {
  text-decoration: none;
  color: white;
}

/* 底部选择框 */
.bottom_box {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  width: 100%;
  height: 1.44rem;
  display: flex;
  bottom: 0;
  z-index: 10;
  padding: 0 1.39rem;
  justify-content: space-between;
  background-color: #fdfdfe;
  /* background-color: rgba(255, 255, 255, 1); */
  /* box-shadow:  0px -0.01rem 0.01rem #ccc; */
}

.bar {
  box-sizing: border-box;
  display: flex;

  padding-top: 0.36rem;
  position: relative;
}

.redmessage {
  position: absolute;
  right: 0;
  top: 0.3rem;
  width: 0.2rem;
  height: 0.2rem;
  background-color: red;
  border-radius: 50%;
}

.games_img {
  width: 0.82rem;
  height: 0.91rem;
}

/* 敬请期待弹出框 */
.coming_soon {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coming_soon_bg {
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.1;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.coming_soon_text {
  position: relative;
  z-index: 2;
  border-radius: 0.3rem;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.4rem 0.6rem;
}

/* 全局关闭滚动条 */

::-webkit-scrollbar {
  /* width: 0; */
  -webkit-overflow-scrolling: touch;
}
.hidescrollbar::-webkit-scrollbar {
  -webkit-overflow-scrolling: touch;
}

/* 全局背景样式 */
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  object-fit: cover;
}

div {
  box-sizing: border-box;
}

.Share—bt {
  width: 4.76rem;
  height: 1.32rem;
  background-color: #ffffff;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border: solid 0.02rem rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #05080b;
  border-radius: 0.6rem;
  font-size: 0.48rem;
}

.Play-bt {
  width: 4.76rem;
  height: 1.32rem;
  background-color: #fff34f;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.6rem;
  color: #05080b;
  font-size: 0.48rem;
}

/* 这里是断网 */
.update {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.update_url {
  display: flex;
  justify-content: center;
}

.update_img {
  width: 1.74rem;
  height: 1.74rem;
}

.update_text {
  margin-top: 0.5rem;
  text-align: center;
  font-size: 0.36rem;
  color: #1b1b1b;
}

.update_botton {
  width: 2.49rem;
  height: 0.72rem;
  border: solid 0.02rem #22baa8;
  text-align: center;
  line-height: 0.72rem;
  margin: 0.83rem auto 0;
  border-radius: 0.6rem;
  font-size: 0.36rem;
  color: #22baa8;
}

/* 这里是无数据 */
.no_data {
  height: calc(100% - 1.7rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.no_data_url {
  display: flex;
  justify-content: center;
}

.no_data_img {
  width: 1.74rem;
  height: 1.74rem;
}

.no_data_text {
  margin-top: 0.5rem;
  text-align: center;
  font-size: 0.36rem;
  color: var(--AppNoResult);
}

.no_data_botton {
  width: 2.49rem;
  height: 0.72rem;
  border: solid 0.02rem #22baa8;
  text-align: center;
  line-height: 0.72rem;
  margin: 0.83rem auto 0;
  border-radius: 0.6rem;
  font-size: 0.36rem;
  color: #22baa8;
}

/* 全局邀请提示框 */
.Invites {
  width: 100%;
  position: fixed;
  top: 0rem;
  left: 0;
  display: flex;
  z-index: 10;
  justify-content: center;
}

.Invites_box {
  width: 10.08rem;
  height: 2.54rem;
  background-color: #ffffff;
  box-shadow: 0px 0px 0.16rem 0px rgba(5, 8, 11, 0.39);
  border-radius: 0.3rem;
  padding: 0.36rem 0.21rem 0 0.41rem;
}

.Invites_user {
  display: flex;
}

.Invites_user_url {
  width: 1.2rem;
  height: 1.2rem;
}

.Invites_user_img {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
}

.Invites_user_box {
  margin-left: 0.38rem;
}

.Invites_user_name {
  font-size: 0.42rem;

  color: #1b1b1b;
}

.Invites_user_Invites {
  margin-top: 0.1rem;
  line-height: 0.3rem;
}

.Invites_user_Invites_text1 {
  font-size: 0.3rem;

  color: #1b1b1b;
}

.Invites_user_Invites_text2 {
  font-size: 0.3rem;

  color: #22baa8;
}

.Invites_botton {
  display: flex;
  justify-content: flex-end;
}

.Invites_botton_close {
  width: 1.14rem;
  height: 0.72rem;
  background-color: #ffffff;
  box-shadow: inset 0px -0.06rem 0px 0px rgba(0, 0, 0, 0.05);
  border: solid 0.02rem rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.6rem;
}

.Invites_botton_close_img {
  width: 0.23rem;
  height: 0.23rem;
}

.Invites_botton_join {
  margin-left: 0.43rem;
  width: 1.48rem;
  height: 0.72rem;
  background-color: #fff34f;
  box-shadow: inset 0px -0.05rem 0px 0px rgba(0, 0, 0, 0.06);
  color: #1b1b1b;
  font-size: 0.36rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.6rem;
}

.imgs {
  position: relative;
}

.imgs {
  background: url("data:image/png;base64,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")
    no-repeat center;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue